/* eslint-disable import/prefer-default-export */
import { planStore } from './model';

export const getPlanStore = planStore;
